var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { Color } from '@atomic/obj.constants';
export var ActivityIndicatorStyled = styled(FontAwesomeIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  display: inline-block;\n"], ["\n  color: ", ";\n  display: inline-block;\n"])), function (props) { return (props.light == null ? 'inherit' : props.light ? Color.White : Color.Primary); });
var templateObject_1;
